<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{ locale.guest_group_management }}</h2>
      <div class="innerContent">
        <!-- 새 인원 그룹 -->
        <div class="mt15 mb15">
          <div class="innerTitle setLabel">{{ locale.new_guest_group }}</div>
          <div class="guestGroupForm">
            <SetLanguageValue
              :locale="locale"
              :langValue="newGuestGroup.groupName"
              class="groupName" />
            <button
              type="button"
              class="btn btnPrimary btnAdd"
              @click.stop="addGroup">
              {{ locale.add }}
            </button>
          </div>
        </div>
        <!-- //새 인원 그룹 -->
        <!-- 인원 그룹 리스트 -->
        <ul class="guestGroupList">
          <li v-for="item in guestTypeItems"
            :key="item.groupId">
            <div class="groupName">
              <SetLanguageValue
                :locale="locale"
                :langValue="item.groupName" />
              <p class="groupId">{{ item.groupId }}</p>
            </div>
            <button
              type="button"
              class="btn btnDarkWhite btnUpdate"
              :disabled="!isChangedGroup(item)"
              @click.stop="updateGroup(item.groupId)">
              {{ locale.change }}
            </button>
            <button
              type="button"
              class="btnDel"
              @click.stop="delGroup(item.groupId)">
            </button>
          </li>
        </ul>
        <!-- //인원 그룹 리스트 -->
      </div>
    </div>
  </div>
</template>

<script>
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'CompositeGuestGroup',
  props: [
    'locale',
    'defaultLang',
    'catCode'
  ],
  components: {
    SetLanguageValue
  },
  computed: {
    getShopResultData () {
      return this.$store.getters['shop/getShopResultData']
    },
  },
  created () {
    this.init()
  },
  data () {
    return {
      guestTypeItems: [],
      newGuestGroup: {
        groupId: '',
        groupName: LANG.valueObj(''),
      }
    }
  },
  methods: {
    async init () {
      this.$store.commit('onLoading', true)
      await this.getGuestTypeItems()
      this.$store.commit('onLoading', false)
    },
    isEqualLangObject (a, b) {
      if (!a || !b) return false

      const keysA = Object.keys(a)
      const keysB = Object.keys(b)

      if (keysA.length !== keysB.length) return false

      return keysA.every(key => Object.prototype.hasOwnProperty.call(b, key) && a[key] === b[key])
    },
    isChangedGroup (item) {
      return !this.isEqualLangObject(item?.groupName, item?.originName)
    },
    async getGuestTypeItems () {
      try {
        const guestTypeItems = await this.$store.dispatch('shop/getGuestTypeItems', this.catCode)
        const items = guestTypeItems?.message || []

        this.guestTypeItems = items.map(item => ({
          ...item,
          originName: { ...item.groupName }
        }))
      } finally {}
    },
    setGuestGroup () {
      this.setGuestTypeItems = !this.setGuestTypeItems
    },
    async addGroup () {
      const data = {
        catCode: this.catCode,
        groupId: UNIQUE.uniqueId8(),
        groupName: this.newGuestGroup.groupName
      }
      this.$store.commit('onLoading', true)
      try {
        const res = await this.$store.dispatch('shop/putGuestTypeItems', data)
        if (res?.status === 200) {
          alert(this.locale.complete_add)
          await this.getGuestTypeItems()
          this.newGuestGroup.groupName = LANG.valueObj('')
        }
        if (res?.status === 403) {
          const code = res?.message?.code || 500
          const codeMessage = this.getShopResultData(code)
          const alertMessage = (codeMessage && this.locale[`alert_${codeMessage}`]) || code
          alert(alertMessage)
        }
      } finally {
        this.$store.commit('onLoading', false)
      }
    },
    async updateGroup (groupId) {
      const item = this.guestTypeItems?.find(item => item.groupId === groupId)

      if (!item) return
      if (!this.isChangedGroup(item)) return

      if (window.confirm(this.locale.confirm_change_guest_group_name)) {
        this.$store.commit('onLoading', true)
        try {
          const data = {
            catCode: this.catCode,
            groupId: groupId,
            groupName: item.groupName
          }
          const res = await this.$store.dispatch('shop/putGuestTypeItems', data)
          if (res?.status === 200) {
            alert(this.locale.complete_update)
            await this.getGuestTypeItems()
          }
          if (res?.status === 403) {
            const code = res?.message?.code || 500
            const codeMessage = this.getShopResultData(code)
            const alertMessage = (codeMessage && this.locale[`alert_${codeMessage}`]) || code
            alert(alertMessage)
          }
        } finally {
          this.$store.commit('onLoading', false)
        }
      }
    },
    async delGroup (groupId) {
      if (window.confirm(this.locale.confirm_delete_guest_group)) {
        const item = this.guestTypeItems?.find(item => item.groupId === groupId)

        if (!item) return

        this.$store.commit('onLoading', true)
        try {
          const data = {
            catCode: this.catCode,
            groupId: groupId
          }
          const res = await this.$store.dispatch('shop/delGuestTypeItems', data)
          if (res?.status === 200) {
            alert(this.locale.complete_delete)
            await this.getGuestTypeItems()
          }
          if (res?.status === 403) {
            const code = res?.message?.code || 500
            const codeMessage = this.getShopResultData(code)
            const alertMessage = (codeMessage && this.locale[`alert_${codeMessage}`]) || code
            alert(alertMessage)
          }
        } finally {
          this.$store.commit('onLoading', false)
        }
      }
    },
    close () {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 400px;
  }
}
.innerContent {
  display: flex;
  flex-direction: column;
  overflow: auto;;
}
.guestGroupForm {
  display: flex;
  align-items: center;
  .groupName {
    flex: 1;
  }
  .btnAdd {
    align-self: stretch;
    margin-left: 8px;
    min-width: 0;
  }
}
.guestGroupList {
  overflow: auto;
  li {
    display: flex;
    align-items: center;
    position: relative;
    padding: 8px 32px 8px 8px;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
    & + li {
      border-top: none;
    }
    &:first-of-type {
      border-radius: 4px 4px 0 0;
    }
    &:last-of-type {
      border-radius: 0 0 4px 4px;
    }
  }
  .groupName {
    flex: 1;
  }
  .groupId {
    position: absolute;
    top: 4px;
    left: 8px;
    padding-right: 4px;
    font-size: 10px;
    color: $color-lgrey;
    background: $color-white;
  }
  .btnUpdate {
    align-self: stretch;
    margin-left: 8px;
    min-width: 0;
  }
  .btnDel {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 100%;
    background: url('~@/assets/img/ico_close_black.svg') 4px 8px / 12px no-repeat;
    opacity: 0.4;
  }
}
</style>
